import { createAction } from '@reduxjs/toolkit';

export const createOffer = createAction('[Offers] createOffer');
export const createOfferSuccess = createAction('[Offers] createOfferSuccess');
export const getOffers = createAction('[Offers] getOffers');
export const getOffersSuccess = createAction('[Offers] getOffersSuccess');
export const setCreateInProgress = createAction('[Offers] setCreateInProgress');
export const getOfferSocketMessage = createAction('[Offer] getOfferSocketMessage');
